module.exports = __webpack_public_path__ + "static/media/9-E2EAcademy.02d01456.png";